/**
 * New Action UI should be controlled by system_actions and action_category
 *
 * action_param_name  参数名称
 * action_param_hint  参数说明
 * action_param_mode  参数编辑方式
 *                    0 默认，输入框
 *                    1 拖动条
 *                    2 场景选择下拉列表
 *                    3 计数器选择下拉列表
 *                    4 语言下拉列表
 **/

const system_actions = [
  {
    action_cell_guid: 'E80DDF60-5A19-44F2-958B-B518205F7CDF',
    action_cell_name: '跳关',
    action_name_id: 'an_32_1',
    action_cell_desc: '下一关',
    action_cell_id: 1,
    hidden: 0,
    device_type: 32,
    device_id: 1,
    device_op: 1,
  },
  {
    action_cell_guid: '0FD76062-85A9-4F95-8B04-372F9DF6EB55',
    action_cell_name: '收房间完成',
    action_name_id: 'an_34_1',
    action_cell_desc: '',
    action_cell_id: 2,
    hidden: 0,
    device_type: 36,
    device_id: 1,
    device_op: 1,
  },
  {
    action_cell_guid: '432E74C7-272A-4D12-A802-937BA5DFEF83',
    action_cell_name: '主题开始',
    action_name_id: 'an_35_1',
    action_cell_desc: '',
    action_cell_id: 3,
    hidden: 0,
    device_type: 35,
    device_id: 1,
    device_op: 1,
  },
  {
    action_cell_guid: '5C45DF27-FA8F-4680-A1FE-69DF7BE26C10',
    action_cell_name: '主题结束',
    action_name_id: 'an_36_1',
    action_cell_desc: '',
    action_cell_id: 4,
    hidden: 0,
    device_type: 36,
    device_id: 1,
    device_op: 1,
  },
  {
    action_cell_guid: '3261DF27-FA8F-4680-A1FD-69DF7BE26C10',
    action_cell_name: '流程复位',
    action_name_id: 'an_30_9',
    action_cell_desc: '',
    action_cell_id: 5,
    hidden: 0,
    device_type: 37,
    device_id: 1,
    device_op: 1,
  },
  {
    action_cell_guid: '3261D927-FA8F-1680-B1FD-69DF7BE26C10',
    action_cell_name: '场景效果触发',
    action_name_id: 'an_39_1',
    action_cell_desc: '',
    action_cell_id: 6,
    hidden: 0,
    device_type: 39,
    device_id: 1,
    device_op: 1,
  },
  {
    action_cell_guid: '',
    action_cell_name: '预留系统动作3',
    action_name_id: 'an_37_1',
    action_cell_desc: '',
    action_cell_id: 7,
    hidden: 1,
    device_type: 0,
    device_id: 0,
    device_op: 0,
  },
  {
    action_cell_guid: '',
    action_cell_name: '预留系统动作4',
    action_name_id: 'an_37_2',
    action_cell_desc: '',
    action_cell_id: 8,
    hidden: 1,
    device_type: 0,
    device_id: 0,
    device_op: 0,
  },
  {
    action_cell_guid: '',
    action_cell_name: '预留系统动作5',
    action_name_id: 'an_37_3',
    action_cell_desc: '',
    action_cell_id: 9,
    hidden: 1,
    device_type: 0,
    device_id: 0,
    device_op: 0,
  },
  {
    action_cell_guid: '',
    action_cell_name: '预留系统动作6',
    action_name_id: 'an_37_4',
    action_cell_desc: '',
    action_cell_id: 10,
    hidden: 1,
    device_type: 0,
    device_id: 0,
    device_op: 0,
  },
]

const action_category = [
  {
    name: '系统动作',
    dj_type: 0,
    action_types: [
      {
        action_name: '启动',
        action_name_id: 'an_0_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_0_0',
        action_value: 0,
      },
    ],
  },
  {
    name: '端口组',
    dj_type: 1,
    action_types: [
      {
        action_name: '启动',
        action_name_id: 'an_1_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_1_0',
        action_value: 0,
      },
    ],
  },
  {
    name: '网络设备',
    dj_type: 2,
    action_types: [
      {
        action_name: '启动',
        action_name_id: 'an_2_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_2_0',
        action_value: 0,
      },
    ],
  },
  {
    name: '输入端口',
    dj_type: 3,
    action_types: [
      {
        action_name: '启动',
        action_name_id: 'an_3_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_3_0',
        action_value: 0,
      },
    ],
  },
  {
    name: '输出端口',
    dj_type: 4,
    action_types: [
      {
        action_name: '启动',
        action_name_id: 'an_4_1',
        action_value: 1,
        action_param: false,
        action_param_min: 0,
        action_param_max: 0,
        action_param_hint: '',
        action_param_name: '',
        action_param_mode: 0,
      },
      {
        action_name: '停止',
        action_name_id: 'an_4_0',
        action_value: 0,
        action_param: false,
        action_param_min: 0,
        action_param_max: 0,
        action_param_hint: '',
        action_param_name: '',
        action_param_mode: 0,
      },
      {
        action_name: '设置亮度',
        action_name_id: 'an_4_2',
        action_value: 2,
        action_param: true,
        action_param_min: 0,
        action_param_max: 100,
        action_param_hint: '',
        action_param_name: '亮度值',
        action_param_mode: 0,
      },
      {
        action_name: '状态反转',
        action_name_id: 'an_4_11',
        action_value: 11,
        action_param: false,
        action_param_min: 0,
        action_param_max: 0,
        action_param_hint: '',
        action_param_name: '',
        action_param_mode: 0,
      },      
    ],
  },
  {
    name: '门',
    dj_type: 5,
    action_types: [
      {
        action_name: '开/解锁',
        action_name_id: 'an_5_0',
        action_value: 0,
      },
      {
        action_name: '关/闭合',
        action_name_id: 'an_5_1',
        action_value: 1,
      },
      {
        action_name: '反转',
        action_name_id: 'an_5_2',
        action_value: 2,
      },
    ],
  },
  {
    name: '灯',
    dj_type: 7,
    action_types: [
      {
        action_name: '打开',
        action_name_id: 'an_7_1',
        action_value: 1,
      },
      {
        action_name: '关闭',
        action_name_id: 'an_7_0',
        action_value: 0,
      },
      {
        action_name: '设置亮度',
        action_name_id: 'an_7_2',
        action_value: 2,
        action_param: true
      },
    ],
  },
  {
    name: '音效',
    dj_type: 8,
    action_types: [
      {
        action_name: '播放',
        action_name_id: 'an_8_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_8_0',
        action_value: 0,
      },
      {
        action_name: '设置音量',
        action_name_id: 'an_8_4',
        action_value: 4,
        action_param: true,
        action_param_min: 0,
        action_param_max: 100,
        action_param_hint: '',
        action_param_name: '音量值',
        action_param_mode: 0,
      },
    ],
  },
  {
    name: '超时音效',
    dj_type: 9,
    action_types: [
      {
        action_name: '停止',
        action_name_id: 'an_9_0',
        action_value: 0,
      },
      {
        action_name: '播放',
        action_name_id: 'an_9_1',
        action_value: 1,
      },
    ],
  },
  {
    name: '背景音',
    dj_type: 10,
    action_types: [
      {
        action_name: '播放',
        action_name_id: 'an_10_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_10_0',
        action_value: 0,
      },
      {
        action_name: '恢复',
        action_name_id: 'an_10_2',
        action_value: 2,
      },
      {
        action_name: '暂停',
        action_name_id: 'an_10_3',
        action_value: 3,
      },
      {
        action_name: '设置音量',
        action_name_id: 'an_10_4',
        action_value: 4,
        action_param: true,
        action_param_min: 0,
        action_param_max: 100,
        action_param_hint: '',
        action_param_name: '音量值',
        action_param_mode: 0,
      },
      {
        action_name: '优先级播放',
        action_name_id: 'an_10_5',
        action_value: 5,
        action_param: true,
        action_param_min: 1,
        action_param_max: 100,
        action_param_hint: '数值越大越高',
        action_param_name: '优先级',
        action_param_mode: 0,
      },
    ],
  },
  {
    name: '视频',
    dj_type: 11,
    action_types: [
      {
        action_name: '播放',
        action_name_id: 'an_11_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_11_0',
        action_value: 0,
      },
      {
        action_name: '恢复',
        action_name_id: 'an_11_2',
        action_value: 2,
      },
      {
        action_name: '暂停',
        action_name_id: 'an_11_3',
        action_value: 3,
      },
      {
        action_name: '循环模式',
        action_name_id: 'an_11_5',
        action_value: 5,
      },
    ],
  },
  {
    name: '图片',
    dj_type: 12,
    action_types: [
      {
        action_name: '播放',
        action_name_id: 'an_12_1',
        action_value: 1,
      },
      {
        action_name: '恢复',
        action_name_id: 'an_12_2',
        action_value: 2,
      },
      {
        action_name: '暂停',
        action_name_id: 'an_12_3',
        action_value: 3,
      },
    ],
  },
  {
    name: '网络互动',
    dj_type: 13,
    action_types: [
      {
        action_name: '启动',
        action_name_id: 'an_13_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_13_0',
        action_value: 0,
      },
      {
        action_name: '恢复',
        action_name_id: 'an_13_2',
        action_value: 2,
      },
      {
        action_name: '暂停',
        action_name_id: 'an_13_3',
        action_value: 3,
      },
    ],
  },
  {
    name: '计数器',
    dj_type: 14,
    action_types: [
      {
        action_name: '停止',
        action_name_id: 'an_14_0',
        action_value: 0,
        action_param: false
      },
      {
        action_name: '启动',
        action_name_id: 'an_14_1',
        action_value: 1,
        action_param: false
      },
      {
        action_name: '赋值',
        action_name_id: 'an_14_2',
        action_value: 2,
        action_param: true
      },
      {
        action_name: '加',
        action_name_id: 'an_14_4',
        action_value: 4,
        action_param: true
      },
      {
        action_name: '减',
        action_name_id: 'an_14_5',
        action_value: 5,
        action_param: true
      },
      {
        action_name: '乘',
        action_name_id: 'an_14_6',
        action_value: 6,
        action_param: true
      },
      {
        action_name: '除',
        action_name_id: 'an_14_7',
        action_value: 7,
        action_param: true
      },
      {
        action_name: '产生随机值',
        action_name_id: 'an_14_10',
        action_value: 10,
        action_param: true
      },
      {
        action_name: '加上',
        action_name_id: 'an_14_12',
        action_value: 12,
        action_param: true,
        action_param_mode: 3
      },
      {
        action_name: '减去',
        action_name_id: 'an_14_13',
        action_value: 13,
        action_param: true,
        action_param_mode: 3
      },
      {
        action_name: '乘以',
        action_name_id: 'an_14_14',
        action_value: 14,
        action_param: true,
        action_param_mode: 3
      },
      {
        action_name: '除以',
        action_name_id: 'an_14_15',
        action_value: 15,
        action_param: true,
        action_param_mode: 3
      },
    ],
  },
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  {
    name: '任务',
    dj_type: 30,
    action_types: [
      {
        action_name: '启动',
        action_name_id: 'an_30_1',
        action_value: 1,
      },
      {
        action_name: '停止',
        action_name_id: 'an_30_0',
        action_value: 0,
      },
      {
        action_name: '重设计时',
        action_name_id: 'an_30_8',
        action_value: 8,
      },
      {
        action_name: '流程复位',
        action_name_id: 'an_30_9',
        action_value: 9,
      },
      {
        action_name: '流程跳关',
        action_name_id: 'an_30_3',
        action_value: 3,
      },
    ],
  },

  {
    name: '始终执行',
    dj_type: 31,
    action_types: [
      {
        action_name: '',
        action_name_id: 'an_31_1',
        action_value: 1,
      },
    ],
  },

  {
    name: '网络设备就绪',
    dj_type: 33,
    action_types: [
      {
        action_name: '',
        action_name_id: 'an_33_1',
        action_value: 1,
      },
    ],
  },

  {
    name: '跳关',
    dj_type: 32,
    action_types: [
      {
        action_name: '',
        action_name_id: 'an_32_1',
        action_value: 1,
      },
    ],
  },
  {
    name: '房间收拾',
    dj_type: 34,
    action_types: [
      {
        action_name: '',
        action_name_id: 'an_34_1',
        action_value: 1,
      },
    ],
  },
  {
    name: '主题开始',
    dj_type: 35,
    action_types: [
      {
        action_name: '',
        action_name_id: 'an_35_1',
        action_value: 1,
      },
    ],
  },
  {
    name: '主题通关',
    dj_type: 36,
    action_types: [
      {
        action_name: '',
        action_name_id: 'an_36_1',
        action_value: 1,
      },
    ],
  },
  {
    name: '场景效果触发',
    dj_type: 39,
    action_types: [
      {
        action_name: '',
        action_name_id: 'an_39_1',
        action_value: 1,
        action_param: true
      },
    ],
  },
  {
    name: '语言设置',
    dj_type: 40,
    action_types: [
      {
        action_name: '',
        action_name_id: 'an_40_1',
        action_value: 1,
        action_param: true,
        action_param_min: 0,
        action_param_max: 5,
        action_param_hint: '0 默认，1中文，2粤语，3英语，4日语，5韩语',
        action_param_mode: 0,
      },
    ],
  },
]

export function getSystemActions() {
  return system_actions
}

export function getActionCategory() {
  return action_category
}
